module.exports = __webpack_public_path__ + "img/nature-71.98c2011f.jpg";